import { Navigate, Route, Routes } from "react-router-dom";
import ClassMaster from "../ClassMaster/classMaster";
import Sidebar from "../../Components/sideNav/sideBar";
import Navbar from "../../Components/navbar/navbar";
import SubjectMaster from "../SubjectMaster/subjectMaster";
import StudyMaterial from "../StudyMaterial/StudyMaterial";
import ProfilePage from "../Profile/ProfilePage";
import RoutesPath from "../../Utils/RoutesPath";
import QuestionBank from "../QuestionBank/QuestionBank";
import AddStudyMaterial from "../StudyMaterial/AddStudyMaterial";
import AddQuestionBank from "../QuestionBank/AddQuestionBank";
import BulkUpload from "../QuestionBank/BulkUpload";
import Blogcategory from "../Blog/Blogcategory";
import Blog from "../Blog/AddBlog";
import ViewBlog from "../Blog/ViewBlog";

import AddTestimonial from "../Testimonial/AddTestimonial";
import ViweTestimonial from "../Testimonial/ViweTestimonial";
import FAQCategory from "../FAQ/FAQCategory";
import AddFAQ from "../FAQ/AddFAQ";
import ViewAddFAQ from "../FAQ/ViewAddFAQ";
import ContactList from "../Dynamic/ContactList";
import RegistrationListing from "../Reports/RegistrationListing";
import CoordinatorListing from "../Reports/CoordinatorListing";
import SocialMediaContact from "../Dynamic/SocialMediaContact";
import Authors from "../Authors/Authors";
import AddAuthors from "../Authors/AddAuthors";
import PrivacyPolicy from "../Dynamic/PrivacyPolicy";
import TermsandConditions from "../Dynamic/TermsandConditions";
import CancellationPolicy from "../Dynamic/CancellationPolicy";
import AboutUs from "../Dynamic/AboutUs";
import UpdateSlider from "../UpdateSlider/UpdateSlider";
import StateMaster from "../StateMaster/StateMaster";
import DistrictMaster from "../DistrictMaster/DistrictMaster";
import TalukaMaster from "../TalukaMaster/TalukaMaster";
import PincodeMaster from "../PincodeMaster/PincodeMaster";
import MockTest from "../MockTest/MockTest";
import AddMockTest from "../MockTest/AddMockTest";
import Packages from "../Packages/Packages";
import AddPackages from "../Packages/AddPackages";
import Coordinators from "../Coordinator/Coordinators";
import AddCoordinators from "../Coordinator/AddCoordinators";
import CoordinatorDetails from "../Coordinator/CoordinatorsDetails";
import CommissionPercentage from "../Coordinator/CommissionPercentage";
import CoordinatorPayout from "../Coordinator/CoordinatorPayout";
import BharaSetExamListing from "../BharaSetExam/BharaSetExam";
import RegistrationListingView from "../Reports/RegistrationListingView";
import RolesList from "../SubAdmin/RolesList/Roles";
import Privileges from "../SubAdmin/RolesList/Privileges";
import AddSubAdmin from "../SubAdmin/AddSubAdmin";
import ViweSubAdmin from "../SubAdmin/SubAdminList";
import { AuthContext } from "../../Context/authContext";
import { useContext, useEffect, useState } from "react";
import ProtectedRoute from "../../Context/ProtectedRoute";
import PackagePurchased from "../Reports/PackagePurchased";
import AddSchedule from "../BharaSetExam/ScheduleStudentBatch/ScheduleStudentBatch";
import BharaSatResult from "../BharaSetExam/BharatSetResult";
import ScheduleInterview from "../BharaSetExam/ScheduleStudentBatch/ScheduleInterview";
import AddBharatSetExam from "../BharaSetExam/BharaSatCreateExam/AddBharaSatExam";
import ViewExam from "../BharaSetExam/BharaSatCreateExam/ViewBharatSatExam";
import BharatSatQuestionsDetails from "../BharaSetExam/BharaSatCreateExam/BharaSatQuestionDetails";
import StudentDetailsEdit from "../Reports/StudentDetailsEdit";
import BharatSatExamResult from "../BharaSetExam/BharaSatCreateExam/BharatSatExamResult";
import ReviewerQuestionList from "../Reviewer/ReviewerQuestionList";
import History from "../Reviewer/ReviewerHistory";
import ReviewerHistory from "../Reviewer/ReviewerHistory";
import ReviewerAddQuestionBank from "../Reviewer/ReviewerAddQutionBank";
import ViewCoupans from "../Coupans/viewCoupans";
import CreateCoupans from "../Coupans/createCoupans";
import StudentBatchList from "../BharaSetExam/BharaSatCreateExam/StudentBatchList";
import UpdateMobileBanner from "../UpdateSlider/updateMobileBanner";
import SeoPage from "../Blog/Seo";
import ViewStudents from "../Students/ViewStudents";
import StudentBulkUpload from "../Students/BulkuploadStudents";
import AddStudents from "../Students/AddStudents";

const Dashboard = () => {
  const { user } = useContext(AuthContext);
  return (
    <div className="d-flex">
      <Sidebar /> {/* Include Sidebar component */}
      <div className="mainLayout-content">
        <Navbar /> {/* Include Navbar component */}
        <div className="main_content contentSection scroll_bar">
          <Routes>
            <Route element={<ProtectedRoute />}>
              <Route
                element={
                  <ProtectedRoute
                    requiredParameter="Class Master"
                    requiredAction="read"
                  />
                }
              >
                <Route
                  path={RoutesPath.classMaster}
                  element={<ClassMaster />}
                />
              </Route>
              <Route
                element={
                  <ProtectedRoute
                    requiredParameter="State Master"
                    requiredAction="read"
                  />
                }
              >
                <Route
                  path={RoutesPath.stateMaster}
                  element={<StateMaster />}
                />
              </Route>
              <Route
                element={
                  <ProtectedRoute
                    requiredParameter="District Master"
                    requiredAction="read"
                  />
                }
              >
                <Route
                  path={RoutesPath.districtMaster}
                  element={<DistrictMaster />}
                />
              </Route>
              <Route
                element={
                  <ProtectedRoute
                    requiredParameter="Taluka Master"
                    requiredAction="read"
                  />
                }
              >
                <Route
                  path={RoutesPath.talukaMaster}
                  element={<TalukaMaster />}
                />
              </Route>
              <Route
                element={
                  <ProtectedRoute
                    requiredParameter="Pincode Master"
                    requiredAction="read"
                  />
                }
              >
                <Route
                  path={RoutesPath.pincodeMaster}
                  element={<PincodeMaster />}
                />
              </Route>
              <Route
                element={
                  <ProtectedRoute
                    requiredParameter="Subject Master"
                    requiredAction="read"
                  />
                }
              >
                <Route
                  path={RoutesPath.subjectMaster}
                  element={<SubjectMaster />}
                />
              </Route>
              <Route
                element={
                  <ProtectedRoute
                    requiredParameter="Study material"
                    requiredAction="read"
                  />
                }
              >
                <Route
                  path={RoutesPath.viewStudyMaterial}
                  element={<StudyMaterial />}
                />
              </Route>
              <Route
                element={
                  <ProtectedRoute
                    requiredParameter="Study material"
                    requiredAction="update"
                  />
                }
              >
                <Route
                  path={RoutesPath.editStudyMaterial}
                  element={<AddStudyMaterial />}
                />
              </Route>
              <Route
                element={
                  <ProtectedRoute
                    requiredParameter="Study material"
                    requiredAction="create"
                  />
                }
              >
                <Route
                  path={RoutesPath.addStudyMaterial}
                  element={<AddStudyMaterial />}
                />
              </Route>

              <Route
                element={
                  <ProtectedRoute
                    requiredParameter="Question Bank"
                    requiredAction="read"
                  />
                }
              >
                <Route
                  path={RoutesPath.viewQuestionBank}
                  element={<QuestionBank />}
                />
                <Route
                  path={RoutesPath.bulkUploadQuestions}
                  element={<BulkUpload />}
                />
              </Route>
              <Route
                element={
                  <ProtectedRoute
                    requiredParameter="Question Bank"
                    requiredAction="update"
                  />
                }
              >
                <Route
                  path={RoutesPath.editQuestionBank}
                  element={<AddQuestionBank />}
                />
              </Route>
              <Route
                element={
                  <ProtectedRoute
                    requiredParameter="Question Bank"
                    requiredAction="create"
                  />
                }
              >
                <Route
                  path={RoutesPath.addQuestionBank}
                  element={<AddQuestionBank />}
                />
              </Route>

              <Route path={RoutesPath.profile} element={<ProfilePage />}>
                <Route path={RoutesPath.viewProfile} element={null} />
                <Route path={RoutesPath.changePasswordProfile} element={null} />
              </Route>
              <Route
                element={
                  <ProtectedRoute
                    requiredParameter="Blogs"
                    requiredAction="read"
                  />
                }
              >
                <Route
                  path={RoutesPath.blogcategory}
                  element={<Blogcategory />}
                />
                <Route path={RoutesPath.viewBlog} element={<ViewBlog />} />
                <Route path={RoutesPath.seopage} element={<SeoPage />} />
                <Route path={RoutesPath.authors} element={<Authors />} />
              </Route>
              <Route
                element={
                  <ProtectedRoute
                    requiredParameter="Blogs"
                    requiredAction="update"
                  />
                }
              >
                <Route path={RoutesPath.editblog} element={<Blog />} />
                <Route path={RoutesPath.editAuthors} element={<AddAuthors />} />
              </Route>
              <Route
                element={
                  <ProtectedRoute
                    requiredParameter="Blogs"
                    requiredAction="create"
                  />
                }
              >
                <Route path={RoutesPath.blog} element={<Blog />} />
                <Route path={RoutesPath.addAuthors} element={<AddAuthors />} />
              </Route>
              <Route
                element={
                  <ProtectedRoute
                    requiredParameter="Mock Test"
                    requiredAction="read"
                  />
                }
              >
                <Route path={RoutesPath.viewMockTest} element={<MockTest />} />
              </Route>
              <Route
                element={
                  <ProtectedRoute
                    requiredParameter="Mock Test"
                    requiredAction="update"
                  />
                }
              >
                <Route
                  path={RoutesPath.editMockTest}
                  element={<AddMockTest />}
                />
              </Route>
              <Route
                element={
                  <ProtectedRoute
                    requiredParameter="Mock Test"
                    requiredAction="create"
                  />
                }
              >
                <Route
                  path={RoutesPath.addMockTest}
                  element={<AddMockTest />}
                />
              </Route>
              <Route
                element={
                  <ProtectedRoute
                    requiredParameter="Testimonials"
                    requiredAction="read"
                  />
                }
              >
                <Route
                  path={RoutesPath.testimonial}
                  element={<ViweTestimonial />}
                />
              </Route>
              <Route
                element={
                  <ProtectedRoute
                    requiredParameter="Testimonials"
                    requiredAction="update"
                  />
                }
              >
                <Route
                  path={RoutesPath.editTestimonial}
                  element={<AddTestimonial />}
                />
              </Route>
              <Route
                element={
                  <ProtectedRoute
                    requiredParameter="Testimonials"
                    requiredAction="create"
                  />
                }
              >
                <Route
                  path={RoutesPath.addTestimonial}
                  element={<AddTestimonial />}
                />
              </Route>
              <Route
                element={
                  <ProtectedRoute
                    requiredParameter="Faq's"
                    requiredAction="read"
                  />
                }
              >
                <Route
                  path={RoutesPath.faqCategory}
                  element={<FAQCategory />}
                />
                <Route path={RoutesPath.viewFaq} element={<ViewAddFAQ />} />
              </Route>
              <Route
                element={
                  <ProtectedRoute
                    requiredParameter="Faq's"
                    requiredAction="update"
                  />
                }
              >
                <Route path={RoutesPath.editFaq} element={<AddFAQ />} />
              </Route>
              <Route
                element={
                  <ProtectedRoute
                    requiredParameter="Faq's"
                    requiredAction="create"
                  />
                }
              >
                <Route path={RoutesPath.addFaq} element={<AddFAQ />} />
              </Route>
              <Route
                element={
                  <ProtectedRoute
                    requiredParameter="Packages"
                    requiredAction="read"
                  />
                }
              >
                <Route path={RoutesPath.viewPackages} element={<Packages />} />
              </Route>
              <Route
                element={
                  <ProtectedRoute
                    requiredParameter="Packages"
                    requiredAction="update"
                  />
                }
              >
                <Route
                  path={RoutesPath.editPackages}
                  element={<AddPackages />}
                />
              </Route>
              <Route
                element={
                  <ProtectedRoute
                    requiredParameter="Packages"
                    requiredAction="create"
                  />
                }
              >
                <Route
                  path={RoutesPath.addPackages}
                  element={<AddPackages />}
                />
              </Route>
              <Route
                element={
                  <ProtectedRoute
                    requiredParameter="Coordinator"
                    requiredAction="read"
                  />
                }
              >
                <Route
                  path={RoutesPath.viewCoordinator}
                  element={<Coordinators />}
                />
                <Route
                  path={`${RoutesPath.coordinatordetails}/:id`}
                  element={<CoordinatorDetails />}
                />
                <Route
                  path={`${RoutesPath.commissionpercentage}/:id`}
                  element={<CommissionPercentage />}
                />
                <Route
                  path={`${RoutesPath.coordinatorpayout}/:id`}
                  element={<CoordinatorPayout />}
                />
              </Route>
              <Route
                element={
                  <ProtectedRoute
                    requiredParameter="Coordinator"
                    requiredAction="update"
                  />
                }
              >
                <Route
                  path={RoutesPath.editCoordinator}
                  element={<AddCoordinators />}
                />
              </Route>
              <Route
                element={
                  <ProtectedRoute
                    requiredParameter="Coordinator"
                    requiredAction="create"
                  />
                }
              >
                <Route
                  path={RoutesPath.addCoordinator}
                  element={<AddCoordinators />}
                />
              </Route>
              <Route
                element={
                  <ProtectedRoute
                    requiredParameter="Dynamic"
                    requiredAction="read"
                  />
                }
              >
                <Route
                  path={RoutesPath.contactList}
                  element={<ContactList />}
                />

                <Route
                  path={RoutesPath.socialMediaContact}
                  element={<SocialMediaContact />}
                />
                <Route
                  path={RoutesPath.privacyPolicy}
                  element={<PrivacyPolicy />}
                />
                <Route
                  path={RoutesPath.termsandConditions}
                  element={<TermsandConditions />}
                />
                <Route
                  path={RoutesPath.cancellationPolicy}
                  element={<CancellationPolicy />}
                />
                <Route path={RoutesPath.aboutUs} element={<AboutUs />} />
              </Route>
              <Route
                element={
                  <ProtectedRoute
                    requiredParameter="Reports"
                    requiredAction="read"
                  />
                }
              >
                <Route
                  path={RoutesPath.coordinatorPageListing}
                  element={<CoordinatorListing />}
                />
                <Route
                  path={RoutesPath.registrationPageListing}
                  element={<RegistrationListing />}
                />
                {/* <Route
                  path={`${RoutesPath.registrationPageListingView}/:user_id`}
                  element={<RegistrationListingView />}
                /> */}
                <Route
                  path={`${RoutesPath.editstudentdetails}/:user_id`}
                  element={<StudentDetailsEdit />}
                />
                <Route
                  path={RoutesPath.packagePurchasedListing}
                  element={<PackagePurchased />}
                />
              </Route>
              <Route
                element={
                  <ProtectedRoute
                    requiredParameter="Updateslider"
                    requiredAction="read"
                  />
                }
              >
                <Route
                  path={RoutesPath.updateSlider}
                  element={<UpdateSlider />}
                />
              </Route>
              <Route
                element={
                  <ProtectedRoute
                    requiredParameter="Updateslider"
                    requiredAction="read"
                  />
                }
              >
                <Route
                  path={RoutesPath.updatemobilebanner}
                  element={<UpdateMobileBanner />}
                />
              </Route>

              {/* Bharat SAT */}

              <Route element={<ProtectedRoute requiredParameter="Bharat Sat Exam" requiredAction="read" />}>
                <Route path={RoutesPath.bharatsetexamlisting} element={<BharaSetExamListing />} />
                <Route path={RoutesPath.viewexam} element={<ViewExam />} />
                <Route path={`${RoutesPath.studentbatchlist}/:bharatSatExamId`} element={<StudentBatchList />} />
                <Route
                  path={RoutesPath.bharatsatexamresult}
                  element={<BharatSatExamResult />}
                />
                <Route path={`${RoutesPath.bharatSatQuestionsDetails}/:bharatSatExamId`} element={<BharatSatQuestionsDetails />} />
              </Route>

              <Route element={<ProtectedRoute requiredParameter="Bharat Sat Exam" requiredAction="update" />}>
                <Route path={RoutesPath.editexam} element={<AddBharatSetExam />} />
                {/* <Route path={RoutesPath.reveiwerquestionslist} element={<ReviewerQuestionList />} />
                <Route path={RoutesPath.reviewerhistory} element={<ReviewerHistory />} />  */}
              </Route>
              <Route element={<ProtectedRoute requiredParameter="Bharat Sat Exam" requiredAction="create" />}>
                <Route path={RoutesPath.addexam} element={<AddBharatSetExam />} />
                {/* <Route path={RoutesPath.reveiwerquestionslist} element={<ReviewerQuestionList />} />  */}
                {/* <Route path={RoutesPath.reviewerhistory} element={<ReviewerHistory />} />  */}
              </Route>


              <Route element={<ProtectedRoute requiredParameter="Reviewer" requiredAction="read" />}>
                <Route path={RoutesPath.reveiwerquestionslist} element={<ReviewerQuestionList />} />  {/*for showing the page only  */}
                <Route path={RoutesPath.reviewerhistory} element={<ReviewerHistory />} />{/*for showing the page only  */}
              </Route>
              <Route element={<ProtectedRoute requiredParameter="Reviewer" requiredAction="update" />}>
                <Route path={RoutesPath.reveiwerquestionslist} element={<ReviewerQuestionList />} /> {/*for showing the page only  */}
                <Route path={RoutesPath.reviewerhistory} element={<ReviewerHistory />} /> {/*for showing the page only  */}
                <Route path={RoutesPath.revieweraddquestionbank} element={<ReviewerAddQuestionBank />} />{/*for showing the page only  */}
              </Route>
              <Route element={<ProtectedRoute requiredParameter="Reviewer" requiredAction="create" />}>
                <Route path={RoutesPath.reveiwerquestionslist} element={<ReviewerQuestionList />} /> {/*for showing the page only  */}
                <Route path={RoutesPath.reviewerhistory} element={<ReviewerHistory />} /> {/*for showing the page only  */}
                <Route path={RoutesPath.revieweraddquestionbank} element={<ReviewerAddQuestionBank />} />{/*for showing the page only  */}
              </Route>

              {/*Coupans Route */}
              <Route element={<ProtectedRoute requiredParameter="Bharat Sat Exam" requiredAction="read" />}>
                <Route path={RoutesPath.coupanlisting} element={<ViewCoupans />} />
              </Route>

              <Route element={<ProtectedRoute requiredParameter="Bharat Sat Exam" requiredAction="update" />}>
                <Route path={RoutesPath.editcoupan} element={<CreateCoupans />} />
              </Route>
              <Route element={<ProtectedRoute requiredParameter="Bharat Sat Exam" requiredAction="create" />}>
                <Route path={RoutesPath.addcoupans} element={<CreateCoupans />} />
              </Route>

              {/* Students */}

              <Route element={<ProtectedRoute requiredParameter="Students" requiredAction="read" />}>
                <Route path={RoutesPath.viewStudents} element={<ViewStudents />} />
                <Route path={RoutesPath.bulkUploadStudents} element={<StudentBulkUpload />} />
              </Route>
              <Route element={<ProtectedRoute requiredParameter="Students" requiredAction="create" />}>
                <Route path={RoutesPath.addStudents} element={<AddStudents />} />
              </Route>
              <Route element={<ProtectedRoute requiredParameter="Students" requiredAction="update" />}>
                <Route path={RoutesPath.editStudents} element={<AddStudents />} />
              </Route>



              {user?.role_type === 0 && (
                <>
                  <Route path={RoutesPath.roleList} element={<RolesList />} />
                  <Route
                    path={`${RoutesPath.setprivileges}/:role_id`}
                    element={<Privileges />}
                  />
                  <Route
                    path={RoutesPath.addsubadmin}
                    element={<AddSubAdmin />}
                  />
                  <Route
                    path={RoutesPath.subadminlist}
                    element={<ViweSubAdmin />}
                  />
                </>
              )}
            </Route>

            <Route
              path="*"
              element={<Navigate to={RoutesPath.classMaster} />}
            />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
